export const PROJECT_LIST = 'project-list'
export const PROJECT_ITEM = 'project-item'
export const PAPER_LIST = 'paper-list'
export const PAPER_ITEM = 'paper-item'
export const UPLOAD_WIDGET = 'upload-widget'
export const HERO_BANNER = 'hero-banner'
export const HERO_BANNER_TITLE = `${HERO_BANNER}-title`
export const HERO_BANNER_TEXT = `${HERO_BANNER}-text`
export const DASHBOARD_HEADING_ID = 'dashboard-heading-id'
export const UPLOAD_WIDGET_H2_ID = 'upload-widget-h2-id'
export const SEE_ALL_PAPERS = 'seeAllPapersLink'
export const SEE_ALL_PROJECTS = 'seeAllProjectsLink'
